import { render, staticRenderFns } from "./TagsManage.vue?vue&type=template&id=48ad6d55&scoped=true&"
import script from "./TagsManage.vue?vue&type=script&lang=js&"
export * from "./TagsManage.vue?vue&type=script&lang=js&"
import style0 from "./TagsManage.vue?vue&type=style&index=0&id=48ad6d55&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad6d55",
  null
  
)

export default component.exports